import { select, call, put } from 'redux-saga/effects'
import { SocialShareActionCreators } from 'app/reducers/SocialShareRedux'
import socialShare from 'app/services/api/entities/socialShare'

export function* sendEmailShare({ data }) {
  if (!data.email) {
    return
  }
  try {
    const response = yield socialShare.sendEmailShare(data)

    if (response.success()) {
      yield put(SocialShareActionCreators.sendEmailShareSuccess(response.data))
    } else {
      yield put(SocialShareActionCreators.sendEmailShareFailure(response.data))
    }
  } catch (error) {
    yield put(SocialShareActionCreators.sendEmailShareFailure(error))
  }
}
